import { render } from "./BulkStoreElementTable.vue?vue&type=template&id=6f282442&scoped=true&ts=true"
import script from "./BulkStoreElementTable.vue?vue&type=script&lang=ts"
export * from "./BulkStoreElementTable.vue?vue&type=script&lang=ts"

import "./BulkStoreElementTable.vue?vue&type=style&index=0&id=6f282442&scoped=true&lang=css"

import exportComponent from "/home/runner/work/dashboard/dashboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f282442"]])

export default __exports__